/**
 * Where to go after logging in / creating an account (e.g. back to /premium).
 * Only same-site paths are accepted. The Google login leaves the app and comes back via a
 * server redirect, so its target is parked in sessionStorage for a few minutes.
 */
const STORAGE_KEY = 'returnUrlAfterAuth';
const MAX_AGE_MS = 15 * 60 * 1000;

export function safeReturnUrl(value: unknown): string | undefined {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') && value !== '/login'
    ? value
    : undefined;
}

/** before leaving for Google: remember the target, or forget an old one */
export function rememberReturnUrl(value: unknown): void {
  const url = safeReturnUrl(value);
  try {
    if (url) sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ url, at: Date.now() }));
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // storage blocked: the user lands on the default page
  }
}

/** after coming back from Google: the remembered target, once */
export function takeReturnUrl(): string | undefined {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    if (!raw) return undefined;
    const { url, at } = JSON.parse(raw);
    return Date.now() - at < MAX_AGE_MS ? safeReturnUrl(url) : undefined;
  } catch {
    return undefined;
  }
}
